import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// material-ui
import { ButtonBase, Box } from "@mui/material";

// project imports
import config from "../../config";
import { LogoBigDark } from "../../components/LogoBig";
import { MENU_OPEN } from "../../store/actions";

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const defaultId = useSelector((state) => state.customization.defaultId);
    const dispatch = useDispatch();
    return (
        <ButtonBase
            disableRipple
            onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })}
            component={Link}
            to={config.defaultPath}
        >
            <Box sx={{ transform: 'scale(0.7)', transformOrigin: 'left center', ml: 2 }}>
                <LogoBigDark />
            </Box>
        </ButtonBase>
    );
};

export default LogoSection;
